module.exports = __webpack_public_path__ + "img/question.c67e6ad1.svg";